export const MULTIPART_FORM_DATA  = 'multipart/form-data';
export const APPLICATION_JSON = 'application/json';
export const APPLICATION_OCTET_STREAM = 'application/octet-stream';